import { FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import { Controller, RegisterOptions } from 'react-hook-form';

interface Props {
    name: string,
    label: string,
    disabled?: boolean,
    registerOptions?: RegisterOptions<any, any>
}

const SHSwitch : React.FC<Props> = ({name, label, registerOptions, disabled}) => {
    return <Controller name={name} rules={registerOptions} render={({fieldState, field}) => <>
        <FormControlLabel control={<Switch name={field?.name} disabled={disabled} value={field.value} defaultChecked={field?.value === true} onChange={field?.onChange} />} label={label} />
    </>} />
}

export default SHSwitch;